import Resource from './Resource';

type TemplateName = 'verifyDomains' | 'verifyEventDomains' | 'installingScript' | 'requestAddon';

type AdditionalParams = {
	domain?: string;
	alias?: string;
	trial?: boolean;
	domainName?: string;
	hash?: string;
	cname?: string;
};

class SystemMail extends Resource {
	constructor() {
		super('function/system-mail');
	}

	send(templateName: TemplateName, email: string[], additional?: AdditionalParams) {
		return this._postRequest('', { templateName, email, additional }, {}).then(d => d.data);
	}
}

const resource = new SystemMail();

export default resource;
